<template>
  <div class="transactions-tab">
    <div class="section-header">
      <div>
        <h2>Reward Transactions</h2>
        <p>All reward payouts received from your voting session</p>
      </div>
      <div class="total-badge" v-if="totalRewards > 0">
        Total: {{ formatAmount(totalRewards) }} RWF
      </div>
    </div>

    <div class="loading-state" v-if="loading">
      <b-loading :active="true" :is-full-page="false"></b-loading>
    </div>

    <div class="empty-state" v-else-if="!transactions.length">
      <b-icon icon="receipt" size="is-large"></b-icon>
      <h3>No transactions yet</h3>
      <p>Reward payouts from your voting organizer will appear here.</p>
    </div>

    <div class="transactions-list" v-else>
      <div class="transaction-card" v-for="tx in transactions" :key="tx.id">
        <div class="tx-icon">
          <b-icon icon="gift" size="is-medium"></b-icon>
        </div>
        <div class="tx-details">
          <h4>{{ tx.description }}</h4>
          <p class="tx-date">{{ formatDate(tx.created_at) }}</p>
          <span class="tx-type">Reward Payout</span>
        </div>
        <div class="tx-amount">
          <span class="amount">+{{ formatAmount(tx.amount) }}</span>
          <span class="currency">{{ tx.currency }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TransactionsTab',
  data() {
    return {
      loading: true,
      transactions: [],
      totalRewards: 0,
    }
  },
  mounted() {
    this.loadTransactions()
  },
  methods: {
    async loadTransactions() {
      try {
        this.loading = true
        const response = await this.$store.dispatch('PARTICIPANT_GET_TRANSACTIONS')
        if (response.data.status === 'ok') {
          this.transactions = response.data.data.transactions || []
          this.totalRewards = response.data.data.total_rewards || 0
        }
      } catch (error) {
        console.error('Failed to load transactions:', error)
      } finally {
        this.loading = false
      }
    },
    formatAmount(amount) {
      return Number(amount || 0).toLocaleString()
    },
    formatDate(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })
    },
  },
}
</script>

<style lang="scss" scoped>
.transactions-tab {
  .section-header {
    display: flex; justify-content: space-between; align-items: flex-start;
    margin-bottom: 25px; flex-wrap: wrap; gap: 15px;
    h2 { margin: 0; font-size: 20px; color: #1a191b; font-weight: 600; }
    p { margin: 5px 0 0; color: #797979; font-size: 14px; }
    .total-badge {
      background: #fff;
      color: #1a191b;
      padding: 10px 16px;
      border-radius: 4px;
      border: 1px solid #ddd;
      font-weight: 600;
      font-size: 14px;
    }
  }

  .loading-state { min-height: 200px; position: relative; }

  .empty-state {
    background: #fff; border-radius: 4px; padding: 48px 24px;
    text-align: center; border: 1px solid #ddd;
    .icon { color: #ccc; margin-bottom: 15px; }
    h3 { margin: 0 0 8px; color: #555; }
    p { color: #888; font-size: 14px; }
  }

  .transactions-list {
    display: flex; flex-direction: column; gap: 12px;
    .transaction-card {
      background: #fff; border-radius: 4px; padding: 16px 20px;
      border: 1px solid #ddd;
      display: flex; align-items: center; gap: 16px;
      .tx-icon {
        width: 44px; height: 44px; border-radius: 4px;
        background: #fafafa; display: flex; align-items: center; justify-content: center;
        color: var(--wecodefy-secondary-color, #9fc953); flex-shrink: 0;
        border: 1px solid #eee;
      }
      .tx-details {
        flex: 1;
        h4 { margin: 0 0 4px; font-size: 15px; color: #333; font-weight: 600; }
        .tx-date { margin: 0; font-size: 13px; color: #888; }
        .tx-type {
          display: inline-block; margin-top: 6px; font-size: 11px;
          background: #e8f5e9; color: #2e7d32; padding: 2px 8px; border-radius: 4px;
          font-weight: 500; text-transform: uppercase;
        }
      }
      .tx-amount {
        text-align: right; flex-shrink: 0;
        .amount { display: block; font-size: 20px; font-weight: 700; color: #28a745; }
        .currency { font-size: 12px; color: #888; }
      }
    }
  }
}

@media (max-width: 768px) {
  .transactions-tab .transactions-list .transaction-card {
    flex-direction: column; text-align: center; gap: 12px;
    .tx-amount { text-align: center; }
  }
}
</style>
